import React, { useState } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import DeliveryForm from "./components/DeliveryForm";
import DeliveryHistory from "./components/DeliveryHistory";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function RptDelivery(props) {
  const [tabNo, setTabNo] = useState(0);

  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />

      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabNo} onChange={(e, value) => setTabNo(value)}>
            <Tab label="Report" />
            <Tab label="History" />
          </Tabs>
        </Box>
        {
          {
            0: <DeliveryForm profile={props.profile} />,
            1: <DeliveryHistory profile={props.profile} />,
          }[tabNo]
        }
      </Box>
    </div>
  );
}
